<template>
  <div am-notifications>
    <i-card
      v-for="(n, i) in notifications.list"
      :key="i"
      :color="n.type"
    >
    {{ n.message }}
    </i-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TheNotifications',
  computed: mapState(['notifications'])
}
</script>

<style lang="scss">
  [am-notifications] {
    position: fixed;
    left: 1rem;
    bottom: 1rem;
    max-width: 20rem;
    z-index: 100000;

    .card {
      margin-top: var(--margin-top);
      opacity: 0.7;
      &:hover { opacity: 1; }
    }
  }
</style>
